import React from "react";
import ModuleRender from "@components/modules/moduleRender";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";

import ProjectCarouselAtext from "@components/modules/Banner/projectCarouselAtext";
import "./articleSidebar.scss";

const ArticleTextSidebar = ({ moduleData, sidebarData, teamData, page, isProject, extraClass, ...rest }) => {
    if (moduleData.length > 0) {
        // Remove the spacing of modules as we have different spacing in sidebar
        const sidebarDataModified = sidebarData?.map(arr => ({...arr, moduleData: {...arr.moduleData, teamData, sectionSpacing: " ", removeContainer: true}}))
        const moduleDataModified = moduleData.map(arr => ({...arr, moduleData: {...arr.moduleData, sectionSpacing: " ", removeContainer: true}}))
        return(
            <div className="section py-40 py-md-64 py-lg-80 article-text-sidebar section-white" id="article-text-sidebar">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} lg={{ span: 8 }} xl={{ span: 8 }}>
                            <Stack className="gap-40 gap-md-48">
                                {isProject &&
                                <ProjectCarouselAtext ggfx_results={page?.ggfx_results} items={page?.Gallery} imagetransforms={page?.imagetransforms} pageId={page?.id} extraClass={extraClass} {...rest} />
                                }
                                <ModuleRender
                                    moduleData={moduleDataModified}
                                />
                            </Stack>
                        </Col>
                        {sidebarDataModified?.length > 0 &&
                            <Col xs={12} lg={{ span: 4 }} xl={{ span: 3, offset: 1 }} className="">

                                        <Stack
                                            //ref={ref}
                                            //initial="hidden"
                                            //animate={inView ? "visible" : "hidden"}
                                            //variants={fadeInFromTop}
                                            className="gap-24 gap-md-32 gap-lg-32 mt-40 mt-md-56 mt-lg-0 sidebar sidebar-float"
                                        >
                                            <ModuleRender
                                                moduleData={sidebarDataModified}
                                                divider={true}
                                            />
                                        </Stack>

                            </Col>
                        }
                    </Row>
                </Container>
            </div>
        )
    } else {
        return null
    }
}

export default ArticleTextSidebar
